import { axiosReq } from '../utils/request'

// api.pivothawk.com (REACT_APP_API_URL) proxies straight through to the same
// device_sync_api instance these endpoints live on - no separate client
// needed, this just follows the same pattern as services/devices.js.

// deviceMongoId is the device's Mongo _id (row._id), matching the existing
// /device/:deviceId/errors/read convention - not the physical MQTT deviceId.
export const startCalibration = async (deviceMongoId, { sweepDegrees, currentAngle, startNow }) => {
    const res = await axiosReq.post(`/device/${deviceMongoId}/calibration/start`, { sweepDegrees, currentAngle, startNow })
    return res.data
}

export const resolveCalibrationDecision = async (deviceMongoId, action) => {
    const res = await axiosReq.patch(`/device/${deviceMongoId}/calibration/decision`, { action })
    return res.data
}

export const setCalibrationAngle = async (deviceMongoId, angle) => {
    const res = await axiosReq.patch(`/device/${deviceMongoId}/calibration/angle`, { angle })
    return res.data
}
